import stringify from 'json-stable-stringify';

const INFLIGHT_WINDOW_KEY = 'ksys_requests_inflight';
const COMPLETED_WINDOW_KEY = 'ksys_requests_completed';

if (!global[INFLIGHT_WINDOW_KEY]) {
	global[INFLIGHT_WINDOW_KEY] = {};
}

if (!global[COMPLETED_WINDOW_KEY]) {
	global[COMPLETED_WINDOW_KEY] = {};
}

const inflightRequests: { [key: string]: CachableRequest } = global[INFLIGHT_WINDOW_KEY];
const completedRequests: { [key: string]: CachableRequest } = global[COMPLETED_WINDOW_KEY];
export class CachableRequest {
	url: string;
	request: RequestInit;
	key: string;
	cleanResponse: Response;
	response: Response;
	debug: boolean;
	subscribers: ((response: Response) => void)[] = [];
	constructor(url: string, request: RequestInit, debug = false) {
		this.url = url;
		this.request = request;
		this.key = this.getKey();
		this.debug = debug;
	}
	getKey(): string {
		const keyObject = {
			url: this.url,
			request: this.request,
		};
		return stringify(keyObject);
	}
	async fetch(): Promise<Response> {
		// eslint-disable-next-line no-async-promise-executor
		return new Promise(async (resolve) => {
			const inflightRequest = inflightRequests[this.key];
			const completedRequest = completedRequests[this.key];
			if (inflightRequest && !completedRequest) {
				if (this.debug) {
					console.info(`Request INFLIGHT: ${this.key}`);
				}
				if (!inflightRequest.subscribers) {
					inflightRequest.subscribers = [];
				}
				inflightRequest.subscribers.push((response: Response) => {
					this.response = response.clone();
					resolve(this.response);
				});
			} else {
				if (completedRequest) {
					if (this.debug) {
						console.info(`Request from CACHE: ${this.key}`);
					}
					if (inflightRequest) {
						delete inflightRequests[this.key];
					}
					this.response = completedRequest.cleanResponse.clone();
				} else {
					if (this.debug) {
						console.info(`Request CREATED: ${this.key}`);
					}
					inflightRequests[this.key] = this;
					this.cleanResponse = await fetch(this.url, this.request);
					this.response = this.cleanResponse.clone();
					completedRequests[this.key] = this;
					delete inflightRequests[this.key];
					if (this.subscribers && this.subscribers.length > 0) {
						this.subscribers.forEach((subscriber) => subscriber(this.cleanResponse));
					}
				}
				resolve(this.response);
			}
		});
	}
}
